import { useCallback, useMemo, useState } from "react";
import { useDropzone } from "react-dropzone";

interface Props {
	acceptJson?: boolean;
	acceptXml?: boolean;
	validate: (file: string) => void;
}

export default function useUploadMedia({
	acceptJson,
	acceptXml,
	validate,
}: Props) {
	const [isRejected, setIsRejected] = useState(false);

	const accept = useMemo(() => {
		const files: string[] = [];
		if (acceptJson) files.push("application/json");
		if (acceptXml) files.push("text/xml");
		return files;
	}, [acceptJson, acceptXml]);

	const onDrop = useCallback(
		(acceptedFiles, rejectedFiles) => {
			setIsRejected(false);
			if (acceptedFiles[0]) {
				const fileReader = new FileReader();
				fileReader.readAsText(acceptedFiles[0], "UTF-8");
				fileReader.onload = e => {
					validate(e.target?.result as string);
				};
			} else if (rejectedFiles[0]) {
				setIsRejected(true);
			}
		},
		[validate]
	);

	const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
		onDrop,
		...(accept.length > 0 ? { accept } : {}),
		maxFiles: 1,
	});

	return { getRootProps, getInputProps, isDragActive, open, isRejected };
}
